import React from "react";
import "./FilterDropdown.css";
import { isMobile, getTaskName } from "../../../containers/utils";

function SubFilter({
  hoverPopupMenuClosed,
  item,
  subMenuList,
  onItemClickHandler3,
  onItemClickHandler4,
  icon,
}) {
  const clickHandler = (event, subList) => {
    if (onItemClickHandler3) {
      onItemClickHandler3(
        event,
        item.process_key,
        item.name,
        item.icon_class,
        subList
      );
    } else {
      onItemClickHandler4(event, item.process_key, item.name, item.id, subList);
    }
  };

  return (
    <ul
      className={`${
        hoverPopupMenuClosed === true
          ? "hoverPopupMenuClosed filter_dropdown_menu"
          : "sub_list filter_dropdown_menu"
      }`}
    >
      {subMenuList
        && Array.isArray(subMenuList)
        && subMenuList.map((subList) => (
          <li
            key={subList}
            role="presentation"
            style={{ position: "relative" }}
            className="dropdown-item filter_dropdown_item"
            onClick={(event) => clickHandler(event, subList)}
          >
            <span className={icon} />
            {getTaskName(subList)}
          </li>
        ))}
    </ul>
  );
}

const setClassNameIfDropDownPresent = (isPresent) => `${isPresent ? "_withDropDownIcon" : ""}`;

const setSelectedItemClassName = (
  selectedItem,
  splitButtonData,
  dropDownIconName
) => {
  if (selectedItem !== "All Workflows") {
    return splitButtonData
      ? `filter_button_text_split_withIcon${setClassNameIfDropDownPresent(
          dropDownIconName
        )}`
      : `filter_button_text_withIcon${setClassNameIfDropDownPresent(
          dropDownIconName
        )}`;
  }
  return splitButtonData
    ? `filter_button_text_split${setClassNameIfDropDownPresent(
        dropDownIconName
      )}`
    : `filter_button_text${setClassNameIfDropDownPresent(dropDownIconName)}`;
};

const setDropdownExtraClassName = (selectedItemIconName, selectedItem) => {
  return selectedItemIconName
    && selectedItem
    && selectedItem !== "All Workflows"
    ? "filter_dropdown_button_withIcon"
    : "filter_dropdown_button_noIcon";
};

const setOnClickHandler = (
  classes,
  item,
  onItemClickHandler,
  onItemClickHandler2
) => {
  if (classes === "workflow_dropdown_taskPage")
    return item.id === "all_workflows"
      ? onItemClickHandler(item.name)
      : onItemClickHandler2(item.process_key, item.name, item.icon_class);
  if (classes === "attachments_dropdown_taskPage")
    return onItemClickHandler(item.url, item.type, item.id);
  return classes === "workflow_dropdown_processPage"
    || classes === "config_view_workflow_dropdown"
    ? onItemClickHandler(item.name, item.process_key, item.id)
    : onItemClickHandler(item.id);
};

const FilterDropdown = ({
  list,
  classes,
  selectedItem,
  splitButtonData,
  disableComponent,
  dropDownIconName,
  onItemClickHandler,
  onItemClickHandler2,
  onItemClickHandler3,
  onItemClickHandler4,
  selectedItemIconName,
  splitIconClickHandler,
  onMouseEnter,
  tasksTitle,
  onMouseLeave,
  hoverPopupMenuClosed,
  hoverId,
  isDisableSplitButton,
  customCss,
  customSelectLabel,
}) => {
  let subMenuTask = {};
  let subMenuTaskList = {};
  if (tasksTitle) {
    subMenuTask = tasksTitle.filter(
      (task) => Object.keys(task)[0] === hoverId
    )[0];
    if (subMenuTask) {
      subMenuTaskList = Object.values(subMenuTask)[0];
    }
  }

  return (
    <div
      className={`dropdown btn-group filter_dropdown ${classes}`}
      style={customCss?.main_div ? customCss?.main_div : {}}
    >
      <div
        aria-haspopup="true"
        aria-expanded="false"
        data-toggle="dropdown"
        id="dropdownMenuButton"
        className={`btn dropdown-toggle filter_dropdown_button ${
          disableComponent ? "disabled" : ""
        } ${
          splitButtonData && !customCss
            ? "filter_dropdown_button_shortened"
            : ""
        } ${
          isMobile()
            ? setDropdownExtraClassName(selectedItemIconName, selectedItem)
            : ""
        }`}
      >
        {dropDownIconName ? (
          <span className={`dropdown_icon ${dropDownIconName}`} />
        ) : null}
        {selectedItemIconName
        && selectedItem
        && !customSelectLabel
        && selectedItem !== "All Workflows" ? (
          <span
            data-attr={selectedItem}
            className={`workflow_selected_icon ${selectedItemIconName}`}
          />
        ) : null}
        <span
          className={`${
            selectedItemIconName
            && selectedItem
            && setSelectedItemClassName(
              selectedItem,
              splitButtonData,
              dropDownIconName
            )
          } ${customSelectLabel ? "" : "overflow_text_controller"}`}
        >
          {customSelectLabel || selectedItem}
        </span>
        <span className="caret" />
      </div>
      <ul
        className="dropdown-menu filter_dropdown_menu"
        aria-labelledby="dropdownMenuButton"
      >
        {list
          && Array.isArray(list)
          && list.map((item) => (
            <li
              key={item.id}
              role="presentation"
              className="dropdown-item filter_dropdown_item"
              onClick={() => setOnClickHandler(
                  classes,
                  item,
                  onItemClickHandler,
                  onItemClickHandler2
                )
              }
              onMouseEnter={() => ((classes === "workflow_dropdown_taskPage"
                  && item.id !== "all_workflows")
                || classes === "workflow_dropdown_processPage"
                  ? onMouseEnter(item.id)
                  : null)
              }
              onMouseLeave={() => (classes === "workflow_dropdown_taskPage"
                || classes === "workflow_dropdown_processPage"
                  ? onMouseLeave()
                  : null)
              }
            >
              {(item.id !== "all_workflows"
                && classes === "workflow_dropdown_taskPage")
              || classes === "workflow_dropdown_processPage" ? (
                <>
                  {(item.process_state_list
                    && item.process_state_list.length
                    && Object.keys(subMenuTaskList).length === 0)
                  || (item.id !== "all_workflows"
                    && classes === "workflow_dropdown_taskPage") ? (
                    <span className="leftArrow" />
                  ) : null}
                  <span className="icon-apps dropdown-icon" />
                </>
              ) : null}
              <span>{item.name}</span>

              {subMenuTaskList
              && Object.keys(subMenuTaskList).length
              && item.id !== "all_workflows" ? (
                <SubFilter
                  subMenuList={subMenuTaskList}
                  hoverPopupMenuClosed={hoverPopupMenuClosed}
                  item={item}
                  icon="icon-task"
                  onItemClickHandler3={onItemClickHandler3}
                />
              ) : null}

              {item.process_state_list
              && item.process_state_list.length
              && Object.keys(subMenuTaskList).length === 0
              && classes === "workflow_dropdown_processPage" ? (
                <SubFilter
                  subMenuList={item.process_state_list}
                  hoverPopupMenuClosed={hoverPopupMenuClosed}
                  item={item}
                  icon="icon-processState"
                  onItemClickHandler4={onItemClickHandler4}
                />
              ) : null}
            </li>
          ))}
      </ul>
      {splitButtonData ? (
        <button
          type="button"
          onClick={splitIconClickHandler}
          disabled={isDisableSplitButton}
          className="btn filter_dropdown_split_button"
          style={customCss?.filter_btn ? customCss?.filter_btn : {}}
        >
          {splitButtonData}
        </button>
      ) : null}
    </div>
  );
};

FilterDropdown.defaultProps = {
  list: [],
  classes: "",
  selectedItem: "",
  dropDownIconName: "",
  splitButtonData: null,
  disableComponent: false,
  selectedItemIconName: "",
  isDisableSplitButton: false,
};

export default FilterDropdown;
